import { useState } from "react";
import { t } from "../../translations";

import { CircularProgress } from "@mui/material";
import { MdOutlineArrowBackIosNew } from "react-icons/md";
import { useSelector } from "react-redux";
import { service_api } from "../constants/url";

import { createLogger } from "../../utils/logger";
import { getSafeOrigin, safeNavigate } from "../../utils/capacitorSafety";

const logger = createLogger("CheckoutForm");

const CheckoutForm = ({ order_id, amount, setCheckoutPage }) => {
  const lang = useSelector((state) => state.lang);
  const user = useSelector((state) => state.user);

  const [errorMessage, setErrorMessage] = useState(null);
  const [load, setLoad] = useState(false);

  const handlePaymentLinkRedirect = async () => {
    setLoad(true);
    setErrorMessage(null);

    try {
      // Create payment link on your backend
      const response = await fetch(
        `${service_api}/stripe/create-payment-link`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: user?.refresh_token,
            session: import.meta.env.VITE_API_KEY
          },
          body: JSON.stringify({
            amount: parseInt(amount * 100), // Convert to cents
            order_id: order_id,
            success_url: `${getSafeOrigin()}/order/sucessful/complete?order_id=${order_id}`,
            cancel_url: `${getSafeOrigin()}/cart?chef=${user?.selectedChef?._id || ""}`,
            metadata: {
              order_id: order_id,
              user_id: user?._id
            }
          })
        }
      );

      const data = await response.json();

      if (data.success && data.payment_link_url) {
        // Redirect to Stripe's hosted checkout page
        safeNavigate(data.payment_link_url);
      } else {
        setLoad(false);
        setErrorMessage(data.message || "Failed to create payment link");
      }
    } catch (error) {
      setLoad(false);
      setErrorMessage(error.message || "Something went wrong");
      logger.log("Payment link error:", error);
    }
  };

  return (
    <div
      style={{
        width: "100%",
        minHeight: "50vh",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        padding: "20px 0"
      }}
    >
      <div
        className="payment-page-class"
        style={{
          maxWidth: "500px",
          width: "100%",
          padding: "20px",
          margin: "0 auto"
        }}
      >
        <h3
          style={{
            textAlign: "left",
            display: "flex",
            alignItems: "center",
            fontWeight: "300",
            gap: 10,
            marginLeft: -5,
            cursor: "pointer"
          }}
          onClick={() => setCheckoutPage(false)}
        >
          <MdOutlineArrowBackIosNew fontSize={20} color="#FF114D" />
          {t(`common.back_to_cart`, lang)}
        </h3>

        <p
          style={{
            textAlign: "left"
          }}
        >
          {t("commerce.payment_of", lang)} <b>${amount}</b>
        </p>

        <div
          style={{
            backgroundColor: "#f8f9fa",
            padding: "20px",
            borderRadius: "8px",
            marginBottom: "20px",
            textAlign: "center"
          }}
        >
          <h4 style={{ marginBottom: "15px", color: "#495057" }}>
            {t("common.secure_payment", lang)}
          </h4>
          <p
            style={{ fontSize: "14px", color: "#6c757d", marginBottom: "20px" }}
          >
            {t("common.redirect_secure_payment", lang)}
          </p>

          {errorMessage && (
            <div
              style={{
                color: "#FF114D",
                textAlign: "center",
                margin: "15px 0",
                padding: "10px",
                backgroundColor: "#ffe6e6",
                borderRadius: "4px"
              }}
            >
              {errorMessage}
            </div>
          )}

          <button
            onClick={handlePaymentLinkRedirect}
            disabled={load}
            style={{
              width: "100%",
              backgroundColor: "#FF114D",
              color: "#fff",
              fontSize: 16,
              fontWeight: "600",
              padding: "15px 20px",
              border: "none",
              borderRadius: "8px",
              cursor: load ? "not-allowed" : "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px"
            }}
          >
            {load ? (
              <>
                <CircularProgress size={20} color="inherit" />
                {t("common.creating_payment_link", lang)}
              </>
            ) : (
              <>
                🔒 {t("common.pay_securely", lang)} ${amount}
              </>
            )}
          </button>
        </div>

        <div
          style={{ fontSize: "12px", color: "#6c757d", textAlign: "center" }}
        >
          <p>{t("common.powered_by_stripe", lang)}</p>
        </div>
      </div>
    </div>
  );
};

export default CheckoutForm;
